import alert from '@/plugins/alert'
import { Major, Upload, Course } from '@/plugins/api'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    majors: {
      // [id]: {
      //   ...major
      //   majors: []
      // }
    },
    courses: [],
    count: 0
  },
  actions: {
    async fetchMajors ({ commit }, options) {
      const majorList = await Major.fetch(options)
      commit('changeState', { majors: _.keyBy(majorList, 'id') })
    },
    async countMajors ({ commit }, options) {
      try {
        commit('setCount', await Major.count(options))
      } catch (e) {
        alert.error(e)
      }
    },
    async fetchMajor ({ commit }, majorId) {
      const major = await Major.fetchOne(majorId)
      commit('changeDeepState', {
        majors: {
          [major.id]: major
        }
      })
      commit('setCourses', major.courses)
    },
    async createMajor ({ commit }, { data, options }) {
      try {
        if (data.type === 'root') {
          const major = await Major.create(data, options)
          commit('changeDeepState', {
            majors: {
              [major.id]: major
            }
          })
        } else {
          commit('setMajorsChild', await Major.create(data, options))
        }
        alert.success('Tạo thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async updateMajor ({ commit }, { id, ...major }) {
      try {
        const updatedMajor = await Major.update(id, major)
        commit('changeDeepState', {
          majors: {
            [major.id]: updatedMajor
          }
        })
        commit('setCourses', updatedMajor.courses)
        alert.success('Cập nhật thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async removeMajor ({ commit }, id) {
      try {
        await Major.remove(id)
        commit('deleteMajor', id)
      } catch (e) {
        alert.error(e)
      }
    },
    setMajor ({ commit, state }, major) {
      commit('setMajor', major)
    },
    async removeMajors ({ dispatch }, items) {
      for (let item of items) {
        await dispatch('removeMajor', item.id)
      }
    },
    async createCourse ({ commit }, { major, data, options }) {
      try {
        if (!major.courses) major.courses = []
        major.courses.push(await Course.create(data, options))
        commit('setMajors', [major])
      } catch (e) {
        alert.error(e)
      }
    },
    async uploadAvatar ({ commit }, { majorId, formData }) {
      try {
        let data = await Upload.upload(formData)
        commit('setAvatar', { majorId, avatar: data[0] })
        alert.success('Upload successfully!')
      } catch (e) {
        alert.error(e)
      }
    },
    async destroyAvatar ({ commit }, id) {
      try {
        await Upload.destroy(id)
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setMajorsChild (state, major) {
      const list = _.get(state.majors, `${major.root.id}.majors`, [])
      _.set(state.majors, `${major.root.id}.majors`, [...list, major])
      state.majors = {
        ...state.majors
      }
    },
    setCourses (state, courses) {
      state.courses = courses
    },
    removeMajor (state, majorId) {
      delete state.majors[majorId]
      state.majors = { ...state.majors }
    },
    setAvatar (state, { majorId, avatar }) {
      _.set(state.majors, `${majorId}.avatar`, avatar)
      state.majors = { ...state.majors }
    }
  },
  getters: {
    majors: (state) => {
      return Object.values(state.majors)
    },
    major: (state) => (id) => {
      return state.majors[id]
    },
    courses: (state) => {
      return state.courses
    },
    count: (state) => {
      return state.count
    }
  }
}
